module.exports = __webpack_public_path__ + "static/media/cal4.dad008cd.PNG";